'use client';

import { sendGTMEvent } from '@next/third-parties/google';
import { usePathname } from 'next/navigation';
import { useEffect, useLayoutEffect, useRef } from 'react';

import { GTMBaseParams } from '../lib/types';
import { getPageCategory } from '../utils/getPageCategory';
import {
  GtmNavigationSnapshot,
  recordGtmNavigation
} from '../utils/gtmNavigationHistory';

interface GtmBaseEventProps {
  baseParams: Omit<GTMBaseParams, 'pageCategory'>;
}

export const GTMBaseEvent = ({ baseParams }: GtmBaseEventProps) => {
  const pathname = usePathname();
  const navigationRef = useRef<GtmNavigationSnapshot | null>(null);

  useLayoutEffect(() => {
    navigationRef.current = recordGtmNavigation(pathname);
  }, [pathname]);

  useEffect(() => {
    const navigation = navigationRef.current;
    if (!navigation || navigation.isFirstNavigation) return;

    const { virtualPageURL, virtualPageReferrer } = navigation;
    const pageCategory = getPageCategory(pathname);

    const t = setTimeout(() => {
      sendGTMEvent({ ...baseParams, pageCategory });
      sendGTMEvent({
        event: 'updatevirtualpath',
        virtualPageURL,
        virtualPageTitle: document.title,
        virtualPageReferrer
      });
    }, 0);

    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const isBrowser = typeof window !== 'undefined';
  const isDataLayerEmpty =
    isBrowser && (window?.dataLayer === undefined || window?.dataLayer?.length === 0);

  // Инициализируем dataLayer до загрузки GTM скрипта
  if (isDataLayerEmpty) {
    const pageCategory = getPageCategory(pathname);
    sendGTMEvent({ ...baseParams, pageCategory });
  }

  return null;
};
